import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

import {LanguageService} from '../../language/language.service';

@Component({
  selector: 'app-about-us',
  templateUrl: './about-us.component.html',
  styleUrls: ['../pages.scss','./about-us.component.scss']

})
export class AboutUsComponent implements OnInit {

  //constructor(public languageService: LanguageService) { }

  constructor(private meta: Meta, private titleService: Title, public languageService: LanguageService) {}

  ngOnInit(): void {
    // Pobieramy przetłumaczone teksty z sekcji 'seo' w JSON
    const pageTitle = this.languageService.getLang('home title', 'seo');
    const pageDesc = this.languageService.getLang('home desc', 'seo');

    // Aplikujemy je do przeglądarki i wyszukiwarki
    this.titleService.setTitle(pageTitle);
    this.meta.updateTag({ name: 'description', content: pageDesc });
  }
}
//{@searchKeywords 'sibrica software' "database optimisation" "backup database" "restore database" "development process" "software development"}
